import { useMemo } from "react";
import Navbar from "../components/Navbar";
import FaqSection from "../components/FaqSection.js";
import { useParams } from "react-router-dom";
import { usePublicBlogsReadQuery } from "../store/generated.ts";
import { landingDesktopItems, landingMobileItems } from "../data/mockData.js";
import Footer from "../components/Footer.js";

const EvenessBlogDetails = () => {
  const { slug } = useParams();

  const { data, isLoading, isError } = usePublicBlogsReadQuery(
    { slug: String(slug) },
    { skip: !slug },
  );

  const heroSrc = data?.hero_image_url || "";
  const title = data?.title || "";
  const contentHtml = data?.content_md || "";

  const subtitle = useMemo(() => {
    return "";
  }, []);

  return (
    <div>
      {/* Navbar */}
      <Navbar desktopItems={landingDesktopItems} mobileItems={landingMobileItems} />
      <div className="bg-white pl-0 md:pl-[105px] lg:pl-[149px] pr-0 lg:pr-[179px] text-[#444444] font-['Poppins'] font-normal text-sm sm:text-[17px] laeding-[24px]">
        {/* Header */}
        <header className="px-4">
          {/* Wide hero image */}
          <figure className="mt-6">
            {isLoading ? (
              <div className="w-full h-[331px] rounded-lg bg-[#EEF2F5]" />
            ) : (
              <img
                src={heroSrc}
                alt="Blog hero image"
                className="w-full h-[331px] rounded-lg object-cover"
              />
            )}
          </figure>
        </header>

        <div className="px-[40px] lg:px-[176px]">
          <div className="max-w-4xl mx-auto">
            {isLoading ? (
              <div className="mt-[20px] h-8 w-3/4 rounded bg-[#EEF2F5]" />
            ) : (
              <h1 className="text-xl sm:text-2xl md:text-[32px] font-semibold leading-tight mt-[20px]">
                {title}
              </h1>
            )}
            {!isLoading && subtitle ? <p className="mt-3">{subtitle}</p> : null}

            {isError && (
              <div className="mt-4 text-sm text-red-500">
                Failed to load blog. Please try again.
              </div>
            )}
          </div>

          {/* Article */}
          <div className="mt-6">
            <div className="max-w-4xl mx-auto">
              {isLoading ? (
                <div className="space-y-3">
                  <div className="h-4 w-full rounded bg-[#EEF2F5]" />
                  <div className="h-4 w-11/12 rounded bg-[#EEF2F5]" />
                  <div className="h-4 w-10/12 rounded bg-[#EEF2F5]" />
                </div>
              ) : (
                <div
                  className="
                    max-w-none text-[#444444]
                    [&_p]:my-3
                    [&_h2]:mt-6 [&_h2]:mb-3 [&_h2]:text-[22px] [&_h2]:font-semibold [&_h2]:leading-tight
                    [&_h3]:mt-5 [&_h3]:mb-2 [&_h3]:text-[20px] [&_h3]:font-semibold
                    [&_ol]:my-3 [&_ol]:list-decimal [&_ol]:pl-7
                    [&_ul]:my-3 [&_ul]:list-disc [&_ul]:pl-7
                    [&_li]:my-2
                    [&_img]:my-6 [&_img]:w-full [&_img]:rounded-lg
                    [&_a]:underline"
                  dangerouslySetInnerHTML={{ __html: contentHtml }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
      <FaqSection />
      <Footer/>
    </div>
  );
};

export default EvenessBlogDetails;
